<template lang="pug">
.receive-packet-container(@touchmove.prevent)
  .open-new-container
    Lottie.lottie(
      key="bcg_lottie",
      url="https://m.hellobike.com/resource/helloyun/08345/s2xRY_111.json"
    )
    .task-block
      .top-block
        .card-block
          .card-list(v-for="(item,index) in realList")
            .normal-card(v-if="!item.total")
              .normal-top
                .normal-top-money
                  span.big-money {{item.amount}}
                  span.unit {{item.unit}}
                .normal-top-card {{ item.title }}
              .normal-bottom {{item.subtitle}}
            .more-card(v-else)
              .more-word 更多卡券
              .more-money
                span.big-total-money {{item.total}}
                span.total-unit 元
      .middle-block(@click="goToUse")
    .receive-packet-close(@click="closeModal")
      img.close(src="https://m.hellobike.com/resource/helloyun/08345/KyfI3xjHl3.png")
    .shadow
  </template>

<script>
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { desc, getName } from '../utils.js';

export default {
  components: {
    Lottie,
  },
  props: {
    couponInfo: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    realList() {
      if (this.couponInfo.length > 3) {
        const firstTwo = this.couponInfo.slice(0, 2);
        const rest = this.couponInfo.slice(2);
        const moreCard = rest.reduce((v, item) => v + item.detail.propAmount, 0);
        firstTwo.push({ total: moreCard });
        return firstTwo;
      }
      return this.couponInfo;
    },
  },
  mounted() {
  },
  methods: {
    desc,
    getName,
    closeModal() {
      this.$emit('update:show', false);
    },
    goToUse() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_gift_pop',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$emit('update:show', false);
    },

  },
};
</script>
<style lang="less" scoped>
.receive-packet-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 222;
  width: 100%;

  .lottie {
    z-index: 101;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .open-new-container {
    margin-top: 2.48rem;

    .task-block {
      background-size: 100% 100%;
      margin: 0 auto;
      z-index: 101;
      position: relative;

      .top-block {
        margin: 0 auto;
        height: 2.57rem;
        width: 3.54rem;
        background-image: url('https://m.hellobike.com/resource/helloyun/08345/_B6xFNO-RF.png');
        background-size: 100% 100%;
        padding-top: 1.1rem;

        .card-block {
          width: 100%;
          height: 1.06rem;
          padding-left: 0.41rem;
          padding-right: 0.36rem;
          display: flex;
          justify-content: space-between;

          .card-list {
            background-image: url('https://m.hellobike.com/resource/helloyun/08345/3qwsAa90_R.png?x-oss-process=image/quality,q_80');
            background-size: 100% 100%;
            width: 0.87rem;
            height: 1.06rem;

            .normal-card {
              color: #fff;
              text-align: center;

              .normal-top {
                .normal-top-money {
                  margin-top: 0.1rem;
                  margin-bottom: 0.03rem;

                  span.big-money {
                    font-family: "DIN Alternate Bold", sans-serif;
                    font-size: 0.36rem;
                    font-weight: bold;
                    line-height: 0.3rem;
                  }

                  span.unit {
                    font-family: PingFangSC, PingFang SC, sans-serif;
                    font-weight: 400;
                    font-size: 0.12rem;
                    line-height: 0.12rem;
                  }
                }

                .normal-top-card {
                  font-family: PingFangSC, PingFang SC, sans-serif;
                  font-weight: 500;
                  font-size: 0.14rem;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  width: 0.75rem;
                  text-align: center;
                  margin: 0 auto;
                }
              }

              .normal-bottom {
                margin-top: 0.17rem;
                font-family: PingFangSC, PingFang SC, sans-serif;
                font-weight: 400;
                font-size: 0.11rem;
                color: #feeee8;
              }
            }

            .more-card {
              text-align: center;

              .more-word {
                margin-top: 0.2rem;
                font-family: PingFangSC, PingFang SC, sans-serif;
                font-weight: 500;
                font-size: 0.14rem;
                color: #fff;
                line-height: 0.18rem;
              }

              .more-money {
                margin-top: 0.06rem;
                color: #fff;

                span.big-total-money {
                  font-family: "DIN Alternate Bold", sans-serif;
                  font-size: 0.36rem;
                  font-weight: bold;
                  line-height: 0.3rem;
                }

                span.total-unit {
                  font-family: PingFangSC, PingFang SC, sans-serif;
                  font-weight: 400;
                  font-size: 0.12rem;
                  line-height: 0.12rem;
                }
              }
            }
          }
        }
      }

      .middle-block {
        margin: 0 auto;
        background-image: url('https://m.hellobike.com/resource/helloyun/22871/kxDhd_btn.png?x-oss-process=image/quality,q_80');
        background-size: 100% 100%;
        width: 2rem;
        height: 0.44rem;
      }

      .packet-receive-button {
        text-align: center;
        margin: 0.1rem auto 0 auto;
        width: 2.24rem;
        height: 0.54rem;
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/WfgPs9UoGm.png?x-oss-process=image/quality,q_80);
        background-size: 100% 100%;
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 600;
        color: #531900;
        line-height: 0.54rem;
      }
    }

    .receive-packet-close {
      margin-top: 0.3rem;
      display: flex;
      justify-content: center;
      z-index: 101;
      position: relative;

      .close {
        width: 0.3rem;
        height: 0.3rem;
        z-index: 101;
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}
</style>
